class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    // Annahme: ON_CHANGE_DEBOUNCE_TIMER und debounce sind global definiert
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, typeof ON_CHANGE_DEBOUNCE_TIMER !== 'undefined' ? ON_CHANGE_DEBOUNCE_TIMER : 300);


    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    // Annahme: PUB_SUB_EVENTS und subscribe sind global definiert
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'cart-items') {
          return;
        }
        this.onCartUpdate();
      });
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const quantityElement = this.querySelector(`#QuantityInput-${id}`); // Angepasst an neue ID
    if (quantityElement) {
      if (quantityElement.tagName === 'INPUT') {
        quantityElement.value = quantityElement.getAttribute('value');
      } else if (quantityElement.tagName === 'SELECT') {
        // Für Select ist ein "Reset" auf HTML-Attribut-Basis weniger sinnvoll,
        // da der Wert direkt durch die Auswahl gesetzt wird.
        // Ggf. auf den Wert zurücksetzen, den item.quantity beim Laden hatte, falls erforderlich.
      }
      // this.isEnterPressed = false; // Sicherstellen, dass isEnterPressed definiert ist, falls es verwendet wird
    } else {
      console.warn(`CART.JS: Quantity element with ID #QuantityInput-${id} not found in resetQuantityInput.`);
    }
  }

  setValidity(event, index, message) {
    const targetElement = event.target;
    targetElement.setCustomValidity(message);
    targetElement.reportValidity();

    // Der 'index' hier ist event.target.dataset.index, was dem Suffix der ID 'QuantityInput-X' entspricht.
    this.resetQuantityInput(index);

    if (targetElement.tagName === 'INPUT' && typeof targetElement.select === 'function' && !targetElement.hasAttribute('readonly')) {
      targetElement.select();
    }
  }

  validateQuantity(event) {
    const targetElement = event.target;
    const inputValue = parseInt(targetElement.value, 10);
    const index = targetElement.dataset.index; // Dies ist der Suffix der ID, z.B. "1", "2"
    let message = '';
    let isValid = true;

    // Fallback für window.quickOrderListStrings, falls nicht definiert
    const qolStrings = window.quickOrderListStrings || {};
    const minErrorStr = qolStrings.min_error || 'Minimum quantity is [min].';
    const maxErrorStr = qolStrings.max_error || 'Maximum quantity is [max].';
    const stepErrorStr = qolStrings.step_error || 'Quantity must be in increments of [step].';


    if (targetElement.tagName === 'SELECT') {
      // Für Select-Elemente (Bulk-Mengen-Dropdown) ist jede ausgewählte Option gültig.
      // Keine min/max/step Validierung hier.
    } else if (targetElement.tagName === 'INPUT') {
      // Liest min, max, step aus data-Attributen oder nativen HTML-Attributen mit Fallbacks
      const min = parseInt(targetElement.dataset.min, 10) || (targetElement.min ? parseInt(targetElement.min, 10) : 1);
      const max = targetElement.dataset.max ? parseInt(targetElement.dataset.max, 10) : (targetElement.max ? parseInt(targetElement.max, 10) : Infinity);
      const step = parseInt(targetElement.dataset.step, 10) || (targetElement.step ? parseInt(targetElement.step, 10) : 1);

      // --- DEBUGGING LOGS START ---
      console.log("--- CART.JS: Validating Quantity ---");
      console.log("Target Element:", targetElement);
      console.log("targetElement.dataset.step:", targetElement.dataset.step);
      console.log("targetElement.step (HTML attribute value):", targetElement.step);
      console.log("Parsed step variable for validation logic:", step);
      console.log("inputValue for validation:", inputValue);
      console.log("min for validation:", min);
      // --- DEBUGGING LOGS END ---

      if (targetElement.hasAttribute('readonly')) {
        // Wenn das Feld readonly ist, sollten Änderungen nicht möglich sein.
        // Setze den Wert auf den ursprünglichen HTML-Attribut-Wert zurück, falls er manipuliert wurde.
        targetElement.value = targetElement.getAttribute('value');
        isValid = true;
        message = '';
        targetElement.setCustomValidity(''); // Alte Meldungen löschen
        // targetElement.reportValidity(); // Optional, da readonly
        return; // Frühzeitiger Ausstieg für readonly Inputs
      }

      if (isNaN(inputValue)) { // Wenn keine gültige Zahl eingegeben wurde
        isValid = false;
        message = 'Please enter a valid quantity.'; // Oder ein passender String
        // Hier könnte man den Wert auf min oder den alten Wert zurücksetzen
        // targetElement.value = min;
      } else if (inputValue < min) {
        message = minErrorStr.replace('[min]', min);
        isValid = false;
        // Optional: Wert auf Minimum korrigieren
        // targetElement.value = min;
      } else if (inputValue > max) {
        message = maxErrorStr.replace('[max]', max);
        isValid = false;
        // Optional: Wert auf Maximum korrigieren
        // targetElement.value = max;
      } else if (step > 1 && (inputValue - min) % step !== 0) {
        // Die Bedingung (inputValue - min) % step !== 0 prüft, ob die Menge
        // ein Vielfaches des Steps ist, relativ zum Minimum.
        console.log("CART.JS: Condition for step error met. Calculated step for message:", step); // DEBUGGING LOG
        message = stepErrorStr.replace('[step]', step);
        isValid = false;
        // Optional: Wert auf nächsten gültigen Step korrigieren (komplexer)
      }
    } else {
      console.warn('CART.JS: validateQuantity called on unexpected element type:', targetElement.tagName);
      isValid = false;
      message = 'Unexpected error validating quantity.'; // Allgemeiner Fehler
    }

    if (!isValid && message) {
      this.setValidity(event, index, message);
    } else {
      targetElement.setCustomValidity('');
      // Nur reportValidity aufrufen, wenn es ein Input war und vorher eine Meldung gesetzt wurde
      // oder wenn checkValidity fehlschlägt (für native Browser-Validierung)
      if (targetElement.tagName === 'INPUT' && !targetElement.checkValidity()) {
        targetElement.reportValidity();
      }
      // updateQuantity wird nur aufgerufen, wenn die Validierung erfolgreich war
      // oder wenn es ein SELECT war (was wir als immer gültig ansehen)
      this.updateQuantity(
        index, // 'index' ist hier item.index + 1, was die 'line' in updateQuantity ist
        inputValue,
        targetElement.getAttribute('name'), // Sollte 'updates[]' sein
        targetElement.dataset.quantityVariantId // Nur beim <input> vorhanden
      );
    }
  }

  onChange(event) {
    // Sicherstellen, dass das Event von einem unserer erwarteten Elemente kommt
    if (event.target.matches('input.quantity__input[name="updates[]"]') || event.target.matches('select.cart-item__bulk-quantity-select[name="updates[]"]')) {
      this.validateQuantity(event);
    }
  }

  onCartUpdate() {
    // ... (Rest der Funktion bleibt gleich)
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          if (sourceQty) { // Sicherstellen, dass sourceQty gefunden wurde
            this.innerHTML = sourceQty.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    // ... (Rest der Funktion bleibt gleich)
    const sections = [];
    const mainCartItemsEl = document.getElementById('main-cart-items');
    if (mainCartItemsEl && mainCartItemsEl.dataset.id) {
        sections.push({
            id: 'main-cart-items',
            section: mainCartItemsEl.dataset.id,
            selector: '.js-contents',
        });
    }
    sections.push({
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
    });
    sections.push({
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
    });
    const mainCartFooterEl = document.getElementById('main-cart-footer');
    if (mainCartFooterEl && mainCartFooterEl.dataset.id) {
        sections.push({
            id: 'main-cart-footer',
            section: mainCartFooterEl.dataset.id,
            selector: '.js-contents',
        });
    }
    return sections;
  }

  updateQuantity(line, quantity, name, variantId) {
    // ... (Rest der Funktion bleibt gleich)
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    // Annahme: fetchConfig ist global definiert
    fetch(`${routes.cart_change_url}`, { ...(typeof fetchConfig === 'function' ? fetchConfig() : {}), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        // Anpassung des Selektors für quantityElement, um robuster zu sein
        const quantityElement =
          document.getElementById(`QuantityInput-${line}`) || // Unsere neue ID
          document.getElementById(`Quantity-${line}`) || // Alte ID als Fallback
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          if (quantityElement && quantityElement.tagName === 'INPUT') { // Nur für Input den Wert zurücksetzen
            quantityElement.value = quantityElement.getAttribute('value');
          }
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            (document.getElementById(section.id) ? document.getElementById(section.id).querySelector(section.selector) : null) || 
            document.getElementById(section.id);
          if (elementToReplace && parsedState.sections[section.section]) { // Sicherstellen, dass Element und Sektion existieren
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });
        
        // Logik für updatedValue und message
        let updatedQuantityFromState;
        if (parsedState.items && parsedState.items[line - 1]) {
            updatedQuantityFromState = parsedState.items[line - 1].quantity;
        }

        let UImessage = ''; // Umbenannt, um Konflikt mit globaler 'message' zu vermeiden
        if (quantityElement && items.length === parsedState.items.length && updatedQuantityFromState !== parseInt(quantityElement.value)) {
          if (typeof updatedQuantityFromState === 'undefined') {
            UImessage = (window.cartStrings && window.cartStrings.error) || 'An error occurred.';
          } else {
            UImessage = ((window.cartStrings && window.cartStrings.quantityError) || 'Quantity error: [quantity].').replace('[quantity]', updatedQuantityFromState);
          }
        }
        this.updateLiveRegions(line, UImessage);


        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && name && lineItem.querySelector(`[name="${name}"]`)) { // Sicherstellen, dass 'name' existiert
          const focusableElement = lineItem.querySelector(`[name="${name}"]`);
          if (cartDrawerWrapper && typeof trapFocus === 'function') {
            trapFocus(cartDrawerWrapper, focusableElement);
          } else {
            focusableElement.focus();
          }
        } else if (parsedState.item_count === 0 && cartDrawerWrapper && typeof trapFocus === 'function') {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty') || cartDrawerWrapper, cartDrawerWrapper.querySelector('a') || cartDrawerWrapper);
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper && typeof trapFocus === 'function') {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name') || cartDrawerWrapper);
        }
        
        // Annahme: publish und PUB_SUB_EVENTS sind global definiert
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        }
      })
      .catch((e) => { // Fehlerobjekt 'e' hinzufügen für besseres Debugging
        console.error('Error in updateQuantity fetch:', e);
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) { // Sicherstellen, dass das errors-Element existiert
            errors.textContent = (window.cartStrings && window.cartStrings.error) || 'An error occurred while updating the cart.';
        }
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    // ... (Rest der Funktion bleibt gleich)
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
        const errorTextElement = lineItemError.querySelector('.cart-item__error-text');
        if (errorTextElement) { // Sicherstellen, dass das Element existiert
            errorTextElement.innerHTML = message;
        }
    }

    if (this.lineItemStatusElement) { // Sicherstellen, dass es existiert
        this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) { // Sicherstellen, dass es existiert
        cartStatus.setAttribute('aria-hidden', false);
        setTimeout(() => {
          cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    // ... (Rest der Funktion bleibt gleich)
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const element = parsedHTML.querySelector(selector);
    return element ? element.innerHTML : ''; // Fallback, falls Element nicht gefunden
  }

  enableLoading(line) {
    // ... (Rest der Funktion bleibt gleich)
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) { // Sicherstellen, dass es existiert
        mainCartItems.classList.add('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
    }
    if (this.lineItemStatusElement) { // Sicherstellen, dass es existiert
        this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    // ... (Rest der Funktion bleibt gleich)
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) { // Sicherstellen, dass es existiert
        mainCartItems.classList.remove('cart__items--disabled');
    }
    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    // Diese Elemente sind Overlays, sollten standardmäßig .hidden haben
    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          // Annahme: ON_CHANGE_DEBOUNCE_TIMER und debounce sind global definiert
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            // Annahme: fetchConfig ist global definiert
            fetch(`${routes.cart_update_url}`, { ...(typeof fetchConfig === 'function' ? fetchConfig() : {}), ...{ body } });
          }, typeof ON_CHANGE_DEBOUNCE_TIMER !== 'undefined' ? ON_CHANGE_DEBOUNCE_TIMER : 300)
        );
      }
    }
  );
}